module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-snackbar', {
    staticClass: "snackbar",
    attrs: {
      "color": _vm.globalSnackColor,
      "timeout": 4000,
      "right": true,
      "top": true,
      "value": _vm.globalSnackDisplay
    }
  }, [_vm._v("\n\t\t" + _vm._s(_vm.globalSnackMessage) + "\n\t")]), _vm._v(" "), _c('v-container', {
    staticClass: "full_height",
    attrs: {
      "fluid": "true",
      "grid-list-lg": "",
      "text-xs-center": "",
      "ml-0": "",
      "mr-0": ""
    }
  }, [_c('img', {
    staticClass: "mb-4",
    staticStyle: {
      "max-width": "275px"
    },
    attrs: {
      "src": require("../../assets/logo.png")
    }
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "offset-md3": "",
      "md6": "",
      "offset-lg4": "",
      "lg4": ""
    }
  }, [_c('v-card', [_c('v-card-text', {
    staticClass: "px-0"
  }, [_c('h2', [_vm._v("Internet access required")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("Internet connection detected but unable to retrieve data.")]), _vm._v(" "), _c('p', [_vm._v("Please connect to the internet and press OK to restart.")]), _vm._v(" "), _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncCheckNetwork.apply(null, arguments)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}